// Next.js app
import { UserProfile } from '@clerk/nextjs';

export default function Page() {
  return (
    <div className="bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 min-h-screen flex items-center justify-center">
      <div className="bg-white rounded-lg p-8 shadow-lg">
        <h1 className="text-3xl font-semibold mb-4 text-center text-gray-800">
          User Profile of CodeCrush
        </h1>
        <UserProfile />
        <br/>
        <div className="mt-4 flex justify-center space-x-4">
          <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full">
            Save
          </button>
            <a href="./test" className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-full">
              Dashboard
            </a>
        </div>
      </div>
    </div>
  );
}
